/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getError = state => () => state.error

/**
 * @type {object}
 */
const getters = {
  getError
}

export default getters
